(function () {
  'use strict';

  var EMAIL_CODE = ['CHYDEE', '50'].join('');
  var SCRATCH_CODE = ['SCRATCH', '20'].join('');
  var STORAGE_KEY = 'chydeeDiscountState';
  var EMAIL_SUCCESS_KEY = 'chydee_email_capture_success_v1';
  var SCRATCH_SUCCESS_KEY = 'chydee_scratch_unlock_v1';
  var actualDiscountState = 'base';
  var busy = false;
  var timer = null;

  function isState(value) {
    return value === 'base' || value === 'scratch' || value === 'email';
  }

  function storedState() {
    try {
      var value = localStorage.getItem(STORAGE_KEY);
      var emailConfirmed = localStorage.getItem(EMAIL_SUCCESS_KEY) === '1';
      var scratchConfirmed = localStorage.getItem(SCRATCH_SUCCESS_KEY) === '1';
      if (value === 'email' && emailConfirmed) return 'email';
      if (value === 'scratch' && scratchConfirmed) return 'scratch';
      return 'base';
    } catch (error) {
      return 'base';
    }
  }

  function getState() {
    return actualDiscountState !== 'base' ? actualDiscountState : storedState();
  }

  function codeForState(state) {
    return state === 'email' ? EMAIL_CODE : (state === 'scratch' ? SCRATCH_CODE : '');
  }

  function claimPct(state) {
    return state === 'email' ? 50 : (state === 'scratch' ? 20 : 0);
  }

  function pillHTML(state) {
    if (state === 'email') return '<span class="chydee-pill chydee-pill--email">50% OFF</span>';
    if (state === 'scratch') return '<span class="chydee-pill chydee-pill--scratch">20% OFF</span>';
    return '';
  }

  function setState(state) {
    state = isState(state) ? state : 'base';
    try {
      if (state === 'email' && localStorage.getItem(EMAIL_SUCCESS_KEY) !== '1') state = 'base';
      if (state === 'scratch' && localStorage.getItem(SCRATCH_SUCCESS_KEY) !== '1') state = 'base';
      localStorage.setItem(STORAGE_KEY, state);
    } catch (error) {}
    emit(getState());
  }

  function stateFromCart(cart) {
    var labels = [];

    function addApplication(application) {
      if (!application) return;
      ['code', 'title', 'name', 'value'].forEach(function (key) {
        var value = application[key];
        if (typeof value === 'string' && value) labels.push(value.toUpperCase());
      });
    }

    (cart && cart.discount_codes || []).forEach(function (discount) {
      if (discount && discount.applicable === false) return;
      addApplication(discount);
    });

    (cart && (cart.cart_level_discount_applications || cart.discount_applications) || []).forEach(addApplication);

    (cart && cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || item.discount_allocations || []).forEach(function (allocation) {
        addApplication(allocation);
        addApplication(allocation && allocation.discount_application);
      });
    });

    var applied = labels.join(' ');
    if (applied.indexOf(EMAIL_CODE) > -1) return 'email';
    if (applied.indexOf(SCRATCH_CODE) > -1) return 'scratch';
    return 'base';
  }

  function emit(state) {
    state = isState(state) ? state : 'base';
    document.documentElement.classList.toggle('chydee-email', state === 'email');
    document.documentElement.classList.toggle('chydee-scratch', state === 'scratch');
    document.documentElement.classList.toggle('chydee-base', state === 'base');
    document.dispatchEvent(new CustomEvent('chydee:state', { detail: { state: state } }));
  }

  function sync(cart) {
    actualDiscountState = stateFromCart(cart);
    emit(getState());
  }

  function run() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        if (cart) sync(cart);
        else emit(getState());
      })
      .catch(function () { emit(getState()); })
      .then(function () { busy = false; });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 120);
  }

  window.ChydeePriceState = {
    getState: getState,
    setState: setState,
    codeForState: codeForState,
    claimPct: claimPct,
    pillHTML: pillHTML,
    render: function () { emit(getState()); },
    run: run
  };

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('cart:updated', schedule);
  document.addEventListener('cart:refresh', schedule);
  document.addEventListener('chydee:discount-refresh', schedule);
  window.addEventListener('storage', schedule);
  setTimeout(run, 50);
})();
